import { render, staticRenderFns } from "./editGrv.vue?vue&type=template&id=7dd5f056&scoped=true"
import script from "./editGrv.vue?vue&type=script&lang=js"
export * from "./editGrv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd5f056",
  null
  
)

export default component.exports